// "When was it taken?" — the one date a money form asks for. Defaults to today
// and goes back at most BACKDATE_MONTHS; the server holds the same window and
// refuses anything outside it, so this only keeps the picker honest.

import { DateField, Labelled } from '@/components/editor/EditorKit'
import { BACKDATE_MONTHS, backdateBounds } from '@/lib/backdating'
import { fmtDate } from '@/lib/format'

export function BackdateField({
  label,
  value,
  onChange,
  today,
  disabled,
  backdatedHint,
}: {
  label: string
  value: string
  onChange: (date: string) => void
  /** Today in the business's own zone, 'YYYY-MM-DD'. */
  today: string
  disabled?: boolean
  /** What an earlier date means here, e.g. what the receipt will say. */
  backdatedHint: (date: string) => string
}) {
  const { min, max } = backdateBounds(today)
  const hint = value && value !== today
    ? backdatedHint(fmtDate(value))
    : `Leave as today unless it happened earlier — up to ${BACKDATE_MONTHS} months back.`
  return (
    <Labelled label={label} required hint={hint}>
      <DateField value={value} onChange={onChange} min={min} max={max} disabled={disabled} />
    </Labelled>
  )
}
